import React from "react";
import Dashboard from "./components/Dashboard";
import "./styles/App.css";

function App() {
  return (
    <div className="App">
      <Dashboard />
    </div>
  );
}

export default App;
